import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';

import { AuthGuard } from './core/guards/auth.guard';
import { AnnouncementComponent } from './pages/announcement/announcement.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { Page403Component } from './pages/page403/page403.component';
import { Page404Component } from './pages/page404/page404.component';
import { Page500Component } from './pages/page500/page500.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { DepositeFiatCommisionComponent } from './pages/deposite-fiat-comisions/deposite-fiat-commision/deposite-fiat-commision.component';
import { DepositeFiatDetailsComponent } from './pages/deposite-fiat-comisions/deposite-fiat-details/deposite-fiat-details.component';
import { WithdrawStakedDetailsComponent } from './pages/deposite-fiat-comisions/withdraw-staked-details/withdraw-staked-details.component';
import { AdminWalletComponent } from './pages/metamask/admin-wallet/admin-wallet.component';
import { TokenTransactionComponent } from './pages/metamask/token-transaction/token-transaction.component';
import { UserWalletTransactionComponent } from './pages/metamask/user-wallet-transaction/user-wallet-transaction.component';
import { PassbookListComponent } from './pages/user/components/passbook-list/passbook-list.component';
import { FakePassbookComponent } from './pages/user/components/fake-passbook/fake-passbook.component';
import { FakeOrderComponent } from './pages/user/components/fake-order/fake-order.component';
import { FakeCoindcxorderComponent } from './pages/user/components/fake-coindcxorder/fake-coindcxorder.component';
import { UplineRefferelComponent } from './pages/upline-refferel/upline-refferel/upline-refferel.component';
import { MaintananceNotificationComponent } from './pages/maintainance-notification/maintanance-notification/maintanance-notification.component';
import { BlogPageComponent } from './pages/blog-page/blog-page/blog-page.component';
import { AllUserAssetComponent } from './pages/user-asset/all-user-asset/all-user-asset.component';
import { FakeUserCoinDcxComponent } from './pages/user/components/fake-user-coin-dcx/fake-user-coin-dcx.component';
import { ExchangeHistoryComponent } from './pages/arbitrage/components/exchange-history/exchange-history.component';
import { TotalInvestmentComponent } from './pages/arbitrage/components/total-investment/total-investment.component';
import { ExchangeInvestmentComponent } from './pages/arbitrage/components/exchange-investment/exchange-investment.component';
import { LearnPageComponent } from './pages/learn-page/learn-page/learn-page.component';
import { FakeCredUserComponent } from './pages/user/components/fake-cred-user-coin/fake-cred-user-coin.component'
import { FackLocalOrderFilledComponent } from './pages/user/components/fake-local-order-filled/fake-local-order-filled.component';
import { MissingTradeHistoryComponent } from './pages/user/components/missing-tradeHistory/missing-tradeHistory.component';
import { ZeroBalPassbookIssueComponent } from './pages/user/components/zero_bal_passbook_issues/zero_bal_passbook_issues.component'
const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    // canActivate: [AuthGuard],
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./pages/user/user.module').then((m) => m.UserModule)
      },
      {
        path: 'kyc/valid-docs',
        loadChildren: () =>
          import('./pages/manual-kyc/manual-kyc.module').then((m) => m.ManualKycModule)
      },
      {
        path: 'subadmin',
        loadChildren: () =>
          import('./pages/subadmin/subadmin.module').then((m) => m.SubadminModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Sub Admin'
        }
      },
      {
        path: 'newsletter',
        loadChildren: () => import('./pages/subscriber/subscriber.module').then((m) => m.SubscriberModule),
        // canActivate: [AuthGuard],
        data: {
          // type: 'private',
          name: 'News Letter'
        }
      },
      {
        path: 'modules',
        loadChildren: () =>
          import('./pages/modules/modules.module').then((m) => m.ModulesModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Modules'
        }
      },
      {
        path: 'submodules',
        loadChildren: () =>
          import('./pages/submodules/submodules.module').then((m) => m.SubmodulesModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Sub Modules'
        }
      },
      {
        path: 'currency',
        loadChildren: () =>
          import('./pages/currency/currency.module').then((m) => m.CurrencyModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Coin List'
        }
      },
      {
        path: 'passbook',
        component: PassbookListComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Passbook List',
          type: 'private',
          name: 'Passbook List'
        }
      },
      {
        path: 'fake-passbook',
        component: FakePassbookComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake Passbook List',
          type: 'private',
          name: 'Fake Passbook List'
        }
      },
      {
        path: 'zero-bal-passbook-issues',
        component: ZeroBalPassbookIssueComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Zero Bal Passbook Issues',
          type: 'private',
          name: 'Zero Bal Passbook Issues'
        }
      },
      {
        path: 'fake-order',
        component: FakeOrderComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake Binance order',
          type: 'private',
          name: 'Fake Binance order'
        }
      },
      {
        path: 'fake-CoinDcxorder',
        component: FakeCoindcxorderComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake CoinDcx order',
          type: 'private',
          name: 'Fake CoinDcx order'
        }
      },
      {
        path: 'fake-users',
        component: FakeUserCoinDcxComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake CoinDcx Users',
          type: 'private',
          name: 'Fake CoinDcx Users'
        }
      },
      {
        path: 'fake-cred-order',
        component: FakeCredUserComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake Cred order Users',
          type: 'private',
          name: 'Fake Cred order Users'
        }
      },
      {
        path: 'fake-local-filled-order',
        component: FackLocalOrderFilledComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fake Local Filled order',
          type: 'private',
          name: 'Fake '
        }
      },
      {
        path: 'missing-trade-history',
        component: MissingTradeHistoryComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Missing Trade History',
          type: 'private',
          name: 'Fake '
        }
      },
      {
        path: 'exchangehistory',
        component: ExchangeHistoryComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Exchange History',
          type: 'private',
          name: 'exchangehistory'
        }
      },
      {
        path: 'exchangeinvestment',
        component: ExchangeInvestmentComponent,
        canActivate: [],
        data: {
          title: 'Exchange Investment',
          type: 'private',
          name: 'exchangeinvestment'
        }
      },

      {
        path: 'totalinvestment',
        component: TotalInvestmentComponent,
        canActivate: [],
        data: {
          title: 'Total Investment',
          type: 'private',
          name: 'totalinvestment'
        }
      },

      {
        path: 'emailtemplates',
        loadChildren: () =>
          import('./pages/emailtemplates/emailtemplates.module').then((m) => m.EmailtemplatesModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Email Templates'
        }
      },
      {
        path: 'cmspages',
        loadChildren: () =>
          import('./pages/cmspages/cmspages.module').then((m) => m.CmspagesModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'CMS Pages'
        }
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('./pages/contact-us/contact-us.module').then((m) => m.ContactUsModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Contact Us'
        }
      },
      {
        path: 'site-setting',
        loadChildren: () =>
          import('./pages/site-setting/site-setting.module').then((m) => m.SiteSettingModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Site Setting'
        }
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/profile.module').then((m) => m.ProfileModule)
      },
      // {
      //   path: 'changepassword',
      //   loadChildren: () =>
      //     import('./pages/changepassword/changepassword.module').then((m) => m.ChangepasswordModule)
      // },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.module').then((m) => m.SettingsModule)
      },
      {
        path: 'loginhistory',
        loadChildren: () =>
          import('./pages/loginhistory/loginhistory.module').then((m) => m.LoginhistoryModule)
      },


      {
        path: 'spottrade',
        loadChildren: () =>
          import('./pages/spottrade/spottrade.module').then((m) => m.SpottradeModule)
      },

      {
        path: 'subscription',
        loadChildren: () =>
          import('./pages/subscription/subscription.module').then((m) => m.SubscriptionModule)
      },
      {
        path: 'botdetails',
        loadChildren: () =>
          import('./pages/botdetails/botdetails.module').then((m) => m.BotdetailsModule)
      },
      {
        path: 'grid-bot',
        loadChildren: () =>
          import('./pages/gridBotDetails/botdetails.module').then((m) => m.GridBotdetailsModule)
      },
      {
        path: 'admin-trade-bot',
        loadChildren: () =>
          import('./pages/adminTradeBot/botdetails.module').then((m) => m.AdminTradeBotModule)
      },
      {
        path: 'admin-trade-bot-down-side',
        loadChildren: () =>
          import('./pages/hanumanBotDownSide/botdetails.module').then((m) => m.AdminTradeBotDownSideModule)
      },
      {
        path: 'hanuman-trade-bot-up-side',
        loadChildren: () =>
          import('./pages/hanumanBotUpSide/botdetails.module').then((m) => m.AdminTradeBotUpSideModule)
      },
      {
        path: 'guru-bot',
        loadChildren: () =>
          import('./pages/guruBot/botdetails.module').then((m) => m.GuruBotModule)
      },
      {
        path: 'arbitrage-bot',
        loadChildren: () =>
          import('./pages/arbitrageBot/botdetails.module').then((m) => m.GridBotdetailsModule)
      },
      {
        path: 'transfer',
        loadChildren: () =>
          import('./pages/transferhistory/transferhistory.module').then((m) => m.TransferhistoryModule)
      },
      {
        path: 'tradingbot',
        loadChildren: () =>
          import('./pages/tradingbot/tradingbot.module').then((m) => m.TradingbotModule)
      },


      {
        path: 'priceconversion',
        loadChildren: () =>
          import('./pages/priceconversion/priceconversion.module').then((m) => m.PriceconversionModule)
      },
      {
        path: 'walletsummary',
        loadChildren: () =>
          import('./pages/wallet-summary/wallet-summary.module').then((m) => m.PriceconversionModule)
      },
      {
        path: 'adminprofit',
        loadChildren: () =>
          import('./pages/adminprofit/adminprofit.module').then((m) => m.AdminprofitModule)
      },
      {
        path: 'adminwallet',
        loadChildren: () =>
          import('./pages/admin-wallet/admins-wallet.module').then((m) => m.AdminsWalletModule)
      },

      {
        path: 'deposite-commision',
        component: DepositeFiatCommisionComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Deposite commision',
          type: 'private',
          name: 'Deposite commision'
        }
      },

      {
        path: 'commision-details/:id',
        component: DepositeFiatDetailsComponent,
        canActivate: [AuthGuard],

      },
      {
        path: 'withdraw-stake-details/:id',
        component: WithdrawStakedDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'launchpad',
        loadChildren: () =>
          import('./pages/launchpad/launchpad.module').then((m) => m.LaunchpadModule)
      },
      // {
      //   path: 'token-history',
      //   component: PurchaseTokenHistoryComponent,
      //   data: {
      //     title: 'Purchase Token History'
      //   }
      // },
      {
        path: 'announcement',
        component: AnnouncementComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Announcement',
          type: 'private',
          name: 'Announcement'
        }
      },
      {
        path: 'upline-refferel',
        component: UplineRefferelComponent,
        // canActivate: [AuthGuard],
        data: {
          title: 'Upline Referral',
          type: 'private',
          name: 'Upline Referral'
        }
      },
      {
        path: 'maintenance',
        component: MaintananceNotificationComponent,
        //  canActivate: [AuthGuard],
        data: {
          title: 'Upline Referral',
          type: 'private',
          name: 'Upline Referral'
        }
      },
      {
        path: 'learn-page',
        component: LearnPageComponent,
        data: {
          title: 'Learn page',
          type: 'private',
          name: 'Learn Page'
        }
      },
      {
        path: 'blog-page',
        component: BlogPageComponent,
        //  canActivate: [AuthGuard],
        data: {
          title: 'Blog Page',
          type: 'private',
          name: 'Blog Page'
        }
      },
      {
        path: 'allUser-asset',
        component: AllUserAssetComponent,
        //  canActivate: [AuthGuard],
        data: {
          title: 'User Asset',
          //type: 'private',
          name: 'User Asset'
        }
      },
      {
        path: 'sliders',
        loadChildren: () =>
          import('./pages/slider/slider.module').then((m) => m.SliderModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Sliders'
        }
      },
      {
        path: 'airdrop',
        loadChildren: () =>
          import('./pages/airdrop/airdrop.module').then((m) => m.AirdropModule),
      },
      {
        path: 'support-category',
        loadChildren: () =>
          import('./pages/support-category/support-category.module').then((m) => m.SupportCategoryModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Support Category'
        }
      },
      {
        path: 'support-ticket',
        loadChildren: () =>
          import('./pages/support-ticket/support-ticket.module').then((m) => m.SupportTicketModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'Support'
        }
      },
      {
        path: 'earn',
        loadChildren: () =>
          import('./pages/earn/earn.module').then((m) => m.EarnModule)
        // canActivate: [AuthGuard],
        // data: {
        //   type: 'private',
        //   name: 'Earn Coin List'
        // }
      },
      {
        path: 'earn-offers',
        loadChildren: () =>
          import('./pages/earn-offers/earn-offers.module').then((m) => m.EarnOffersModule)
        // canActivate: [AuthGuard],
        // data: {
        //   type: 'private',
        //   name: 'Earn Coin List'
        // }
      },
      {
        path: 'tds',
        loadChildren: () =>
          import('./pages/tds/tds.module').then((m) => m.TDSModule),
        canActivate: [AuthGuard],
        data: {
          type: 'private',
          name: 'TDS Master'
        }
      },
      {
        path: 'meta-wallet',
        component: AdminWalletComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Meta Admin Wallet',
          type: 'private',
          name: 'Meta Admin Wallet'
        }
      },
      {
        path: 'meta-user-wallet',
        component: UserWalletTransactionComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Meta User Transaction',
          type: 'private',
          name: 'Meta User Transaction'
        }
      },
      {
        path: 'meta-user-wallet',
        component: UserWalletTransactionComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Meta Normal Transaction',
          type: 'private',
          name: 'Meta Normal Transaction'
        }
      },
      {
        path: 'meta-token-transaction',
        component: TokenTransactionComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Meta Token Transaction',
          type: 'private',
          name: 'Meta Token Transaction'
        }
      },
      {
        path: '403',
        component: Page403Component,
        data: {
          title: 'Page 403',
        }
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Login Page',
      type: 'auth'
    }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Forgot Password',
      type: 'auth'
    }
  },
  {
    path: 'reset-password/:authToken',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Reset Password',
      type: 'auth'
    }
  },

  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
